export const databaseColumns = {
  Name: 'name',
  Status: 'status',
  Created: 'dateCreated',
};
